export function setThemeColor(theme) {
  const root = document.documentElement

  const colors = {
    default: {
      primary: '#7a59ff',
    },
    microApp: {
      primary: '#00c6f3',
    },
  }

  const selectedTheme = colors[theme] || colors.default

  Object.entries(selectedTheme).forEach(([key, value]) => {
    root.style.setProperty(`--${key}-color`, value)
  })
}
